import {Institution} from '@/interfaces/institution.interface';

export function getInstitutionNameWithSateCode(institution: Partial<Institution> & { name: string }): string {
    if (institution.address && institution.address.state) {
        return `${institution.name} (${institution.address.state})`;
    }
    return institution.name;
}
